import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { st, Button, FormControl, AppSettings, Message, MainView, CompanyFullDecorator } from "lib/index";
import createCompanySettingsView from "modules/settings/createCompanySettingsView";
import { fetchCurrentCompany } from "modules/auth/index";
import { open as openEditPaymentProfileModal } from "modules/settings/EditPaymentProfileModal/index";
import { openIntegration as openIntegrateOnlinePaymentsModal } from "modules/settings/PaymentsSettingsView/index";

import {
  stateSelector,
  initializeView,
  updateModel,
  submit,
  fetchProducts,
  removeOnlineServiceIntegration,
  selectIntegrationServiceType,
} from "./index";
import Hint from "./PaymentsSettingsHint";
import CompanyPaymentProfileRelationFormSection from "./CompanyPaymentProfileRelationFormSection";
import IntegrateOnlinePaymentsModal from "../IntegrateOnlinePaymentsModal/IntegrateOnlinePaymentsModal";

@connect(
  (state) => ({
    products: state.settings.PaymentsSettingsView.products.model,
    fetchLoading: state.auth.fetchLoading || state.settings.PaymentsSettingsView.products.fetchLoading,
    fetchFailed: state.auth.fetchFailed || state.settings.PaymentsSettingsView.products.fetchFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        submit,
        openEditPaymentProfileModal,
        openIntegrateOnlinePaymentsModal,
        selectIntegrationServiceType,
        removeOnlineServiceIntegration,
        fetch: () => (dispatch) => {
          dispatch(fetchCurrentCompany());
          dispatch(fetchProducts());
        },
      },
      dispatch
    )
)
class FormContent extends React.PureComponent {
  componentDidMount() {
    this.props.fetch();
  }

  handleNewPaymentProfileClick(pp) {
    this.props.openEditPaymentProfileModal(pp);
  }

  handleEditPaymentProfileClick(pp, event) {
    event.stopPropagation();
    this.handleNewPaymentProfileClick(pp);
  }

  handleCompanyPaymentProfileRelationChange(nextRelation) {
    const { company, onChange } = this.props;
    onChange(
      new CompanyFullDecorator({
        ...company,
        company_payment_profile_relations: company.company_payment_profile_relations.map((rel) =>
          rel.uuid === nextRelation.uuid ? nextRelation : rel
        ),
      })
    );
  }

  renderPaymentProfiles({ marketplace }) {
    const { company, products } = this.props;
    const profiles = company.payment_profiles.filter((pp) => pp.marketplace === marketplace);
    const hasSomeProfile = profiles.length > 0;
    const canCreate = st.authorize("create", {
      type: "PaymentProfile",
      main_company_id: company.id,
      marketplace,
    });

    return (
      (profiles.length > 0 || canCreate) && (
        <div>
          <h3>
            {!marketplace && I18n.t("papp.settings.PaymentsSettingsView.your_profiles_title")}
            {marketplace && I18n.t("papp.settings.PaymentsSettingsView.marketplace_profiles_title")}
          </h3>
          {!hasSomeProfile && !marketplace && (
            <Message warning visible>
              {I18n.t("papp.settings.PaymentsSettingsView.no_your_profiles_warning")}
            </Message>
          )}
          {profiles.map((pp) => {
            const rel = company.company_payment_profile_relations.find((rel) => rel.payment_profile.id === pp.id);
            return (
              <CompanyPaymentProfileRelationFormSection
                key={rel.uuid}
                pp={pp}
                relation={rel}
                onEditClick={st.authorize("update", pp) && this.handleEditPaymentProfileClick.bind(this, pp)}
                onChange={this.handleCompanyPaymentProfileRelationChange.bind(this)}
                products={products || []}
              />
            );
          })}
          {/* {canCreate && (
            <Button
              as="a"
              basic
              color="blue"
              size="small"
              onClick={this.handleNewPaymentProfileClick.bind(this, {
                marketplace
              })}
            >
              <i className="icon material-icons">add</i>{" "}
              {I18n.t("papp.settings.PaymentsSettingsView.add_new_profile")}
            </Button>
          )} */}
        </div>
      )
    );
  }

  handleAddPaymentsIntegrationClick() {
    this.props.openIntegrateOnlinePaymentsModal();
  }

  handleEditPaymentsIntegrationClick({ dotpay_access, paypal_access }) {
    const serviceType = dotpay_access && !paypal_access ? "dotpay" : "paypal";
    this.props.selectIntegrationServiceType(serviceType);
    this.props.openIntegrateOnlinePaymentsModal();
  }

  handleRemoveClick() {
    const { removeCustomer } = this.props;
    st.confirm({
      // content: I18n.t("papp.customers.EditCustomerModal.remove_confirm_message"),
      content: "Are you sure?",
    }).then((yes) => yes && removeCustomer());
  }

  handleRemoveIntegration() {
    st.confirm({
      // content: I18n.t("papp.customers.EditCustomerModal.remove_confirm_message"),
      content: "Are you sure?",
    }).then((yes) => {
      if (yes) {
        this.props.removeOnlineServiceIntegration();
        this.props.submit();
      }
    });
  }

  renderOnlineServicesIntegration(company) {
    if (!st.authorize.company.supplier && !st.authorize.company.agent) {
      return null;
    }
    return (
      st.authorize.member.role !== "company_employee" &&
      st.authorize.member.role !== "company_admin" && (
        <div style={{ marginBottom: "20px" }}>
          <h3>{company && !company.online_payment_access ? "Integrate online services" : "Integrated service"}</h3>

          <div>
            {company && !company.online_payment_access && (
              <Button
                as="a"
                basic
                color="green"
                size="small"
                onClick={this.handleAddPaymentsIntegrationClick.bind(this)}
              >
                <i className="icon material-icons">add</i> Integrate
              </Button>
            )}
            <div />
            {company.dotpay_access && (
              <Button color="green" onClick={(e) => e.preventDefault()}>
                DotPay connected
              </Button>
            )}
            {company.paypal_access && (
              <Button color="green" onClick={(e) => e.preventDefault()}>
                PayPal connected
              </Button>
            )}
            {(company.dotpay_access || company.paypal_access) && (
              <div style={{ display: "inline" }}>
                <a
                  className="material-icons"
                  style={{ color: "black", cursor: "pointer", margin: "0 5px" }}
                  onClick={this.handleEditPaymentsIntegrationClick.bind(this, company)}
                >
                  edit
                </a>
                <a
                  className="material-icons"
                  style={{ color: "red", cursor: "pointer", margin: "0 5px" }}
                  onClick={this.handleRemoveIntegration.bind(this)}
                >
                  delete
                </a>
              </div>
            )}
          </div>
        </div>
      )
    );
  }

  render() {
    const { company, errors, handleCompanyPropChange, fetchLoading, fetchFailed, fetch } = this.props;
    return (
      <div>
        <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetch} />
        {st.authorize.member.role !== "company_employee" && st.authorize.member.role !== "company_admin" && (
          <FormControl.TextAreaFormGroup
            {...FormControl.addProps(`model.bank_wire_account_description`, {
              errors,
            })}
            value={company.bank_wire_account_description}
            onChange={handleCompanyPropChange.bind(null, "bank_wire_account_description")}
            label={I18n.humanAttributeName("company", "bank_wire_account_description")}
            placeholder={I18n.humanAttributeName("company", "bank_wire_account_description_placeholder")}
            autoHeight
            disabled={st.authorize.member.role !== "global_admin" && st.authorize.member.role !== "main_admin"}
          />
        )}

        {company.supplier && (
          <FormControl.SelectFormGroup
            {...FormControl.addProps(`model.default_product_price_currency`, {
              errors,
            })}
            value={company.default_product_price_currency}
            onChange={handleCompanyPropChange.bind(null, "default_product_price_currency")}
            label={I18n.humanAttributeName("company", "default_product_price_currency")}
            options={AppSettings.backend_currencies.filter((currency) => !["GBP", "TRY"].includes(currency))}
            className="u-smallWidth"
          />
        )}

        <IntegrateOnlinePaymentsModal handleCompanyPropChange={handleCompanyPropChange.bind(this)} />
        {this.renderOnlineServicesIntegration(company)}

        {company.supplier && company.enable_saas && (
          <div>
            {this.renderPaymentProfiles({ marketplace: false })}
            <hr />
          </div>
        )}

        {this.renderPaymentProfiles({ marketplace: true })}
      </div>
    );
  }
}

const PaymentsSettingsView = createCompanySettingsView({
  stateSelector,
  actions: { initializeView, updateModel, submit },
  title: I18n.t("papp.settings.PaymentsSettingsView.title"),
  FormContent,
  Hint,
});

export default PaymentsSettingsView;



// WEBPACK FOOTER //
// ./src/modules/settings/PaymentsSettingsView/PaymentsSettingsView.jsx